<template>
  <div class="navbar-container sf-navbar d-flex align-items-center justify-content-between w-100">

    <!-- ESQUERDA: toggle (mobile) + eyebrow/título da rota -->
    <div class="d-flex align-items-center sf-navbar-left">
      <ul class="nav navbar-nav d-xl-none mb-0">
        <li class="nav-item">
          <b-link
            class="nav-link"
            @click="toggleVerticalMenuActive"
          >
            <feather-icon
              icon="MenuIcon"
              size="21"
            />
          </b-link>
        </li>
      </ul>
      <div class="sf-page-heading">
        <div
          v-if="pageEyebrow"
          class="sf-page-eyebrow"
        >
          {{ pageEyebrow }}
        </div>
        <h1
          v-if="pageTitle"
          class="sf-page-title"
        >
          {{ pageTitle }}
        </h1>
      </div>
    </div>

    <!-- DIREITA: dot · corretora · idioma · notificações · refresh
         (nome/plano/logout ficam só no card do rodapé da sidebar) -->
    <b-navbar-nav class="nav align-items-center sf-navbar-right">
      <span
        class="sf-api-dot"
        title="API"
      />
      <navbar-broker-selector />
      <locale />
      <navbar-notifications />
      <button
        type="button"
        class="sf-nav-icon-btn"
        aria-label="refresh"
        @click="refresh"
      >
        <feather-icon
          icon="RefreshCwIcon"
          size="15"
        />
      </button>
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav,
} from 'bootstrap-vue'
import { getContext } from '@/auth/utils'
import NavbarBrokerSelector from '@/layouts/components/custom/NavbarBrokerSelector.vue'
import NavbarNotifications from '@/layouts/components/custom/NavbarNotifications.vue'
import Locale from './components/Locale.vue'

// route.name -> chave i18n existente (reaproveitadas, sem novas chaves)
const TITLE_KEYS = {
  home: 'spot.titleVisaoGeral',
  'fut-home': 'futures.titleVisaoGeral',
  'spot-compra-aberta': 'Compras abertas',
  'spot-venda-aberta': 'Vendas abertas',
  'spot-cambio': 'Câmbio',
  'spot-relatorio-fechamento': 'Fechamento',
  'spot-relatorio-sinal': 'Sinais',
  'spot-meu-agente': 'Meus agentes',
  'fut-ordem-aberta': 'Ordens abertas',
  'fut-posicao': 'Posições',
  'fut-transfer': 'Transferência',
  'fut-relatorio-fechamento': 'Fechamento',
  'fut-relatorio-sinal': 'Sinais',
  'fut-meu-agente': 'Meus agentes',
  indicacao: 'Indicações',
  notificacao: 'Notificações',
  suporte: 'Suporte',
  tutorial: 'Tutoriais',
  'conta-assinatura': 'Assinatura',
  'conta-configuracao': 'Configurações',
}

export default {
  components: {
    BLink,
    BNavbarNav,
    Locale,
    NavbarBrokerSelector,
    NavbarNotifications,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    pageEyebrow() {
      // a rota é a fonte da verdade; getContext() (localStorage) só p/ rotas compartilhadas
      const path = (this.$route && this.$route.path) || ''
      if (path.startsWith('/futures')) return 'FUTURES'
      if (path.startsWith('/spot')) return 'SPOT'
      const ctx = getContext()
      if (ctx === 'spot') return 'SPOT'
      if (ctx === 'futures') return 'FUTURES'
      return ''
    },
    pageTitle() {
      const meta = this.$route.meta || {}
      if (meta.pageTitle) return this.$t(meta.pageTitle)
      const key = TITLE_KEYS[this.$route.name]
      return key ? this.$t(key) : ''
    },
  },
  methods: {
    refresh() {
      window.location.reload()
    },
  },
}
</script>
